import classNames from 'classnames';

import Diamond from 'components/icons/Diamond';
import { TEMPO_PREMIUM } from 'lib/constants/index';

const MealPrimaryLabel = ({ containerStyle, primaryLabel, hexColor }) => {
  const isTempoPremium = primaryLabel === TEMPO_PREMIUM;
  const primaryLabelText = () => {
    if (isTempoPremium) {
      return 'Premium'.toUpperCase();
    } else {
      return primaryLabel.toUpperCase();
    }
  };

  const tempoDiamond = () => {
    return (
      <span className="mr-1 flex">
        <Diamond />
      </span>
    );
  };

  return (
    <div
      className={classNames(
        'h7 inline-flex items-center overflow-hidden whitespace-nowrap rounded px-2 leading-relaxed tracking-half-px text-white-100 bp1:whitespace-normal',
        containerStyle
      )}
      style={{ backgroundColor: hexColor }}
    >
      {isTempoPremium && tempoDiamond()} {primaryLabelText()}
    </div>
  );
};

MealPrimaryLabel.propTypes = {
  containerStyle: PropTypes.string,
  primaryLabel: PropTypes.string.isRequired,
  hexColor: PropTypes.string,
};

export default MealPrimaryLabel;
